module.exports = __webpack_public_path__ + "static/img/total-supply-icon.5bc0739f.png";